class SkuSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-sku-input]');
    this.results = this.querySelector('[data-sku-results]');
    this.clearBtn = this.querySelector('[data-sku-clear]');
    if (!this.input || !this.results) return;

    this.input.addEventListener('input', this.debounce(() => this.onInput(), 250));
    this.results.addEventListener('click', (event) => this.onPick(event));
    if (this.clearBtn) this.clearBtn.addEventListener('click', () => this.reset());
    document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.close(); });
    this.input.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
  }

  onInput() {
    const term = this.input.value.trim();
    this.toggleClear(term.length > 0);
    this.clearPicked();
    if (term.length < 2) { this.close(); return; }
    this.fetchResults(term);
  }

  clearPicked() {
    ['product', 'variant', 'title', 'handle', 'image', 'sku', 'vendor', 'price', 'option'].forEach((k) => this.removeAttribute('data-picked-' + k));
  }

  async fetchResults(term) {
    try {
      const url = `/search/suggest?q=${encodeURIComponent(term)}&section_id=sku-suggest&resources[type]=product`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Suggest request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const list = doc.querySelector('[data-sku-list]');
      if (list && list.children.length) { this.results.innerHTML = list.outerHTML; this.open(); }
      else this.close();
    } catch (error) {
      this.close();
    }
  }

  onPick(event) {
    const row = event.target.closest('[data-sku]');
    if (!row) return;
    this.input.value = row.getAttribute('data-sku');
    if (row.dataset.productId) this.setAttribute('data-picked-product', row.dataset.productId);
    if (row.dataset.variantId) this.setAttribute('data-picked-variant', row.dataset.variantId);
    if (row.dataset.title) this.setAttribute('data-picked-title', row.dataset.title);
    if (row.dataset.handle) this.setAttribute('data-picked-handle', row.dataset.handle);
    if (row.dataset.image) this.setAttribute('data-picked-image', row.dataset.image);
    if (row.dataset.variantSku) this.setAttribute('data-picked-sku', row.dataset.variantSku);
    if (row.dataset.vendor) this.setAttribute('data-picked-vendor', row.dataset.vendor);
    if (row.dataset.price) this.setAttribute('data-picked-price', row.dataset.price);
    if (row.dataset.option) this.setAttribute('data-picked-option', row.dataset.option);
    this.toggleClear(true);
    this.close();
    this.input.focus();
  }

  reset() {
    this.input.value = '';
    this.clearPicked();
    this.toggleClear(false);
    this.close();
    this.input.focus();
  }

  toggleClear(show) {
    if (!this.clearBtn) return;
    this.clearBtn.classList.toggle('hidden', !show);
    this.clearBtn.classList.toggle('flex', show);
  }

  open() { this.results.classList.remove('hidden'); this.input.setAttribute('aria-expanded', 'true'); }
  close() { this.results.classList.add('hidden'); this.input.setAttribute('aria-expanded', 'false'); }

  debounce(fn, wait) {
    let timer;
    return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn.apply(this, args), wait); };
  }
}

if (!customElements.get('sku-search')) customElements.define('sku-search', SkuSearch);
